// ─────────────────────────────────────────────────────────────────────────────
// First-class subdivision tables keyed by ISO 3166-1 alpha-2 country code.
// Codes follow the ISO 3166-2 convention "<country>-<subdivision>".
// Used by CustomerForm to render a typed subregion dropdown for the countries
// where the catalogue is exhaustive enough to be useful (US states, CA
// provinces and territories, ES autonomous communities and autonomous cities).
// For every other country the form falls back to a free-text input — no entry
// is required here for that case.
// Entries inside each country list are alphabetical by nameEn.
// ─────────────────────────────────────────────────────────────────────────────

export const SUBREGIONS = {
  CA: [
    { code: 'CA-AB', nameEs: 'Alberta',                nameEn: 'Alberta' },
    { code: 'CA-BC', nameEs: 'Columbia Británica',     nameEn: 'British Columbia' },
    { code: 'CA-MB', nameEs: 'Manitoba',               nameEn: 'Manitoba' },
    { code: 'CA-NB', nameEs: 'Nuevo Brunswick',        nameEn: 'New Brunswick' },
    { code: 'CA-NL', nameEs: 'Terranova y Labrador',   nameEn: 'Newfoundland and Labrador' },
    { code: 'CA-NT', nameEs: 'Territorios del Noroeste', nameEn: 'Northwest Territories' },
    { code: 'CA-NS', nameEs: 'Nueva Escocia',          nameEn: 'Nova Scotia' },
    { code: 'CA-NU', nameEs: 'Nunavut',                nameEn: 'Nunavut' },
    { code: 'CA-ON', nameEs: 'Ontario',                nameEn: 'Ontario' },
    { code: 'CA-PE', nameEs: 'Isla del Príncipe Eduardo', nameEn: 'Prince Edward Island' },
    { code: 'CA-QC', nameEs: 'Quebec',                 nameEn: 'Quebec' },
    { code: 'CA-SK', nameEs: 'Saskatchewan',           nameEn: 'Saskatchewan' },
    { code: 'CA-YT', nameEs: 'Yukón',                  nameEn: 'Yukon' },
  ],
  ES: [
    { code: 'ES-AN', nameEs: 'Andalucía',              nameEn: 'Andalusia' },
    { code: 'ES-AR', nameEs: 'Aragón',                 nameEn: 'Aragon' },
    { code: 'ES-AS', nameEs: 'Asturias',               nameEn: 'Asturias' },
    { code: 'ES-IB', nameEs: 'Islas Baleares',         nameEn: 'Balearic Islands' },
    { code: 'ES-PV', nameEs: 'País Vasco',             nameEn: 'Basque Country' },
    { code: 'ES-CN', nameEs: 'Canarias',               nameEn: 'Canary Islands' },
    { code: 'ES-CB', nameEs: 'Cantabria',              nameEn: 'Cantabria' },
    { code: 'ES-CL', nameEs: 'Castilla y León',        nameEn: 'Castile and León' },
    { code: 'ES-CM', nameEs: 'Castilla-La Mancha',     nameEn: 'Castilla-La Mancha' },
    { code: 'ES-CT', nameEs: 'Cataluña',               nameEn: 'Catalonia' },
    { code: 'ES-CE', nameEs: 'Ceuta',                  nameEn: 'Ceuta' },
    { code: 'ES-EX', nameEs: 'Extremadura',            nameEn: 'Extremadura' },
    { code: 'ES-GA', nameEs: 'Galicia',                nameEn: 'Galicia' },
    { code: 'ES-RI', nameEs: 'La Rioja',               nameEn: 'La Rioja' },
    { code: 'ES-MD', nameEs: 'Madrid',                 nameEn: 'Madrid' },
    { code: 'ES-ML', nameEs: 'Melilla',                nameEn: 'Melilla' },
    { code: 'ES-MC', nameEs: 'Murcia',                 nameEn: 'Murcia' },
    { code: 'ES-NC', nameEs: 'Navarra',                nameEn: 'Navarre' },
    { code: 'ES-VC', nameEs: 'Comunidad Valenciana',   nameEn: 'Valencian Community' },
  ],
  US: [
    { code: 'US-AL', nameEs: 'Alabama',        nameEn: 'Alabama' },
    { code: 'US-AK', nameEs: 'Alaska',         nameEn: 'Alaska' },
    { code: 'US-AZ', nameEs: 'Arizona',        nameEn: 'Arizona' },
    { code: 'US-AR', nameEs: 'Arkansas',       nameEn: 'Arkansas' },
    { code: 'US-CA', nameEs: 'California',     nameEn: 'California' },
    { code: 'US-CO', nameEs: 'Colorado',       nameEn: 'Colorado' },
    { code: 'US-CT', nameEs: 'Connecticut',    nameEn: 'Connecticut' },
    { code: 'US-DE', nameEs: 'Delaware',       nameEn: 'Delaware' },
    { code: 'US-FL', nameEs: 'Florida',        nameEn: 'Florida' },
    { code: 'US-GA', nameEs: 'Georgia',        nameEn: 'Georgia' },
    { code: 'US-HI', nameEs: 'Hawái',          nameEn: 'Hawaii' },
    { code: 'US-ID', nameEs: 'Idaho',          nameEn: 'Idaho' },
    { code: 'US-IL', nameEs: 'Illinois',       nameEn: 'Illinois' },
    { code: 'US-IN', nameEs: 'Indiana',        nameEn: 'Indiana' },
    { code: 'US-IA', nameEs: 'Iowa',           nameEn: 'Iowa' },
    { code: 'US-KS', nameEs: 'Kansas',         nameEn: 'Kansas' },
    { code: 'US-KY', nameEs: 'Kentucky',       nameEn: 'Kentucky' },
    { code: 'US-LA', nameEs: 'Luisiana',       nameEn: 'Louisiana' },
    { code: 'US-ME', nameEs: 'Maine',          nameEn: 'Maine' },
    { code: 'US-MD', nameEs: 'Maryland',       nameEn: 'Maryland' },
    { code: 'US-MA', nameEs: 'Massachusetts',  nameEn: 'Massachusetts' },
    { code: 'US-MI', nameEs: 'Míchigan',       nameEn: 'Michigan' },
    { code: 'US-MN', nameEs: 'Minnesota',      nameEn: 'Minnesota' },
    { code: 'US-MS', nameEs: 'Misisipi',       nameEn: 'Mississippi' },
    { code: 'US-MO', nameEs: 'Misuri',         nameEn: 'Missouri' },
    { code: 'US-MT', nameEs: 'Montana',        nameEn: 'Montana' },
    { code: 'US-NE', nameEs: 'Nebraska',       nameEn: 'Nebraska' },
    { code: 'US-NV', nameEs: 'Nevada',         nameEn: 'Nevada' },
    { code: 'US-NH', nameEs: 'Nuevo Hampshire',nameEn: 'New Hampshire' },
    { code: 'US-NJ', nameEs: 'Nueva Jersey',   nameEn: 'New Jersey' },
    { code: 'US-NM', nameEs: 'Nuevo México',   nameEn: 'New Mexico' },
    { code: 'US-NY', nameEs: 'Nueva York',     nameEn: 'New York' },
    { code: 'US-NC', nameEs: 'Carolina del Norte', nameEn: 'North Carolina' },
    { code: 'US-ND', nameEs: 'Dakota del Norte',   nameEn: 'North Dakota' },
    { code: 'US-OH', nameEs: 'Ohio',           nameEn: 'Ohio' },
    { code: 'US-OK', nameEs: 'Oklahoma',       nameEn: 'Oklahoma' },
    { code: 'US-OR', nameEs: 'Oregón',         nameEn: 'Oregon' },
    { code: 'US-PA', nameEs: 'Pensilvania',    nameEn: 'Pennsylvania' },
    { code: 'US-RI', nameEs: 'Rhode Island',   nameEn: 'Rhode Island' },
    { code: 'US-SC', nameEs: 'Carolina del Sur', nameEn: 'South Carolina' },
    { code: 'US-SD', nameEs: 'Dakota del Sur', nameEn: 'South Dakota' },
    { code: 'US-TN', nameEs: 'Tennessee',      nameEn: 'Tennessee' },
    { code: 'US-TX', nameEs: 'Texas',          nameEn: 'Texas' },
    { code: 'US-UT', nameEs: 'Utah',           nameEn: 'Utah' },
    { code: 'US-VT', nameEs: 'Vermont',        nameEn: 'Vermont' },
    { code: 'US-VA', nameEs: 'Virginia',       nameEn: 'Virginia' },
    { code: 'US-WA', nameEs: 'Washington',     nameEn: 'Washington' },
    { code: 'US-WV', nameEs: 'Virginia Occidental', nameEn: 'West Virginia' },
    { code: 'US-WI', nameEs: 'Wisconsin',      nameEn: 'Wisconsin' },
    { code: 'US-WY', nameEs: 'Wyoming',        nameEn: 'Wyoming' },
  ],
};
